import ImageDrawer from "../../../shared/components/media/ImageDrawer";
import { MediaPageProps } from "../../../types/app/mediaTypes";

type StoreTypeImageDrawerProps = {
  show: boolean;
  onClose: () => void;
  onSelect: (imageUrl: string) => void;
  currentImageUrl?: string | null;
  currentName: string;
  pageProps: Pick<
    MediaPageProps,
    "getImageGalleryAction" | "getImageGalleryRequest"
  >;
};

const StoreTypeImageDrawer = ({
  show,
  onClose,
  onSelect,
  currentImageUrl,
  currentName,
  pageProps,
}: StoreTypeImageDrawerProps) => {
  return (
    <ImageDrawer
      show={show}
      onClose={onClose}
      onSelect={onSelect}
      currentImageUrl={currentImageUrl}
      currentName={currentName}
      title="Choose store type image"
      subtitle="Select from your media library."
      tabLabel="Check library"
      confirmLabel="Use image"
      pageProps={pageProps}
    />
  );
};

export default StoreTypeImageDrawer;
